<script setup lang="ts">
import { computed } from 'vue'

interface Props {
	rating: number
	size?: 'sm' | 'md' | 'lg'
}

const props = withDefaults(defineProps<Props>(), {
	showRating: true,
	size: 'md',
})

const starColor = computed(() => {
	if (!props.rating) return 'text-gray-300'
	if (props.rating < 1.5) return 'text-red-500'
	if (props.rating < 2.5) return 'text-orange-500'
	if (props.rating < 3.5) return 'text-yellow-500'
	if (props.rating < 4.5) return 'text-green-400'
	return 'text-green-500'
})

const textSize = computed(() => {
	switch (props.size) {
		case 'sm':
			return 'text-sm'
		case 'lg':
			return 'text-lg'
		case 'md':
			return 'text-base'
	}
})
</script>

<template>
	<div :class="[textSize, 'ml-1', starColor, 'font-bold']">
		{{ rating.toFixed(2) }}
	</div>
</template>
